module.exports = __webpack_public_path__ + "static/media/3.14af0ecb.png";